// extracted by mini-css-extract-plugin
export default {"rotateR":"pages_rotateR__6mnHI"};